export const factorsEn = {
  // BEGIN Michael
  FACTOR: 'Factor',
  FACTORS: 'Factors',
  FACTOR_ACCOUNT_CREATED_SUCCESSFULLY: 'Factor account created successfully!',
  UPDATE_FACTOR_INFORMATION: 'Update Factor Information',
  FACTOR_INFORMATION_UPDATED: 'Factor Information updated successfully!',
  BILLING_TEMPLATE: 'Billing Template',
  BILLING_TEMPLATE_DESCRIPTION: 'Email template for sending e-mails to debtors.',
  CONTACT_INFORMATION: 'Contact Information',
  CONTACT_PHONE: 'Contact Phone',
  CONTACT_EMAIL: 'Contact Email',
  CONTACT_INFORMATION_UPDATED: 'Contact Information updated successfully!',
  UPDATE_CONTACT_INFORMATION: 'Update Contact Information',
  SYSTEM_DEFAULTS: 'System Defaults',
  SYSTEM_DEFAULTS_DESCRIPTION:
    'These values are used when creating entities in the system. Changing these values affects only new entities and does not alter existing ones.',
  VENDOR_DEFAULTS_VALUES: 'Vendor Default Values',
  VENDOR_DEFAULTS_VALUES_UPDATED: 'Vendor Default Values updated successfully!',
  DEBTOR_DEFAULTS_VALUES: 'Debtor Default Values',
  DEBTOR_DEFAULTS_VALUES_UPDATED: 'Debtor Default Values updated successfully!',
  CLIENT_DEFAULTS_VALUES: 'Client Default Values',
  CLIENT_DEFAULTS_VALUES_UPDATED: 'Client Default Values updated successfully!',
  BROKER_DEFAULT_VALUES: 'Broker Default Values',
  BROKER_DEFAULT_VALUES_UPDATED: 'Broker Default Values updated successfully!',
  NO_BUY: 'No Buy',
  NO_BUY_TOOLTIP: 'When enabled, this company is marked as No Buy and cannot be purchased.',
  RELATIONSHIP_DEFAULT_VALUES: 'Relationship Default Values',
  RELATIONSHIP_DEFAULT_VALUES_UPDATED: 'Relationship Default Values updated successfully!',
  CURRENCY_SYMBOL: 'Currency Symbol',
  CURRENCY_SYMBOL_DESCRIPTION: 'Enable or disable Currency Symbol',
  CURRENCY_FILTER: 'Currency Filter',
  CURRENCY_FILTER_DESCRIPTION: 'Enable or disable Currency Filter',
  CURRENT_CURRENCY_FILTER: 'Current Currency Filter',
  PREFERRED_PAYMENT_METHOD_COLUMN: 'Preferred Payment Method Column',
  PREFERRED_PAYMENT_METHOD_COLUMN_DESCRIPTION: 'Show Preferred Payment Method column on pending invoices',
  BENCHMARK: 'Benchmark',
  INVOICE_PROCESSING: 'Invoice Processing',
  PERMISSIONS: 'Permissions',
  REQUIRED_DUE_DATE: 'Required Due Date',
  REQUIRED_DUE_DATE_DESCRIPTION: 'Enable or disable Required Due Date on Invoice Creation',
  COST_OF_FUNDS: 'Cost of Funds',
  COST_OF_FUNDS_DESCRIPTION: 'Enable or disable Cost of Funds calculation',
  UPDATE_COST_OF_FUNDS: 'Update Cost of Funds',
  COST_OF_FUNDS_FIELDS_UPDATED_SUCCESSFULLY: 'Cost of Funds fields updated successfully!',
  // END Michael
  // BEGIN Fco
  BROKER_MOD: 'Broker Mod',
  FACTOR_ENABLE_BROKER_MOD: 'Enable or disable Broker Mod',
  FACTOR_GROUP_SAME_DAY_INVOICES_DESC: 'Merge Invoices from the same day into one payment batch',
  FACTOR_ENABLE_ALLOW_DUPLICATE_REFERENCE_NUMBERS: 'Enable duplicate reference numbers',
  FACTOR_ENABLE_ALLOW_DUPLICATE_REFERENCE_NUMBERS_DESC: 'Allow Invoices to have duplicate reference numbers.',
  // END Fco
  // BEGIN Fabian
  ACTIVATED_FACTOR: 'Activated Factor',
  DESACTIVATED_FACTOR: 'Desactivated Factor',
  ACTIVATED: 'Activated',
  DESACTIVATED: 'Desactivated',
  UPDATED: 'Updated',
  CREATED: 'Created',
  FACTOR_ACTIVATED_SUCCESSFULLY: 'Factor Activated Successfully!',
  FACTOR_DESACTIVATED_SUCCESSFULLY: 'Factor Deactivated Successfully!',
  UPDATE_FACTOR: 'Update Factor',
  CREATE_FACTOR: 'Create Factor',
  CONFIRM_ACTIVATE_FACTOR: 'Are you sure would you like to activate factor from inactive status?',
  CONFIRM_DESACTIVATE_FACTOR: 'Are you sure would you like to deactivate factor from active status?',
  EMAIL_TEMPLATE_ALERT_INFORMATION: 'The variables that can be used in the subject and body can be the following:',
  CLIENT_NAME: 'Client Name',
  DEBTOR_NAME: 'Debtor Name',
  EMAIL_TEMPLATES: 'Email Templates',
  DEFAULT_NOA_TEMPLATE: 'NOA Template',
  DEFAULT_NOA_TEMPLATE_DESCRIPTION: 'NOA template for sending e-mails to debtors.',
  PAYMENT_ACCOUNTS: 'Payment Accounts',
  CREATE_PAYMENT_ACCOUNT: 'Create Payment Account',
  EDIT_PAYMENT_ACCOUNT: 'Edit Payment Account',
  EDIT_PAYMENT_ACCOUNT_SUCCESS: 'Payment Account edited successfully',
  DELETE_PAYMENT_ACCOUNT: 'Are you sure you want to delete this payment account?',
  DELETE_PAYMENT_ACCOUNT_SUCCESS: 'Payment Account deleted successfully',
  DELETE_PAYMENT_ACCOUNT_DISABLED:
    'Removing a payment account is temporarily disabled while a safer deactivation flow is being built. Contact engineering if an account needs to be removed.',
  BACKDATING_PAYMENTS: 'Allow backdating payments',
  BACKDATING_PAYMENTS_DESCRIPTION: 'When applying a payment, accrued fees will be adjusted to the payment date.',
  OVER_ADVANCES: 'Over Advances',
  OVER_ADVANCES_DESCRIPTION: 'Enable Over Advances module',
  OPEN_BALANCE_OVER_ADVANCES: 'Open Balance Over Advances',
  OPEN_BALANCE_OVER_ADVANCES_DESCRIPTION: 'Allow Open Balance over advances, templates and nightly interest',
  OVER_ADVANCE_INTEREST_RECOGNITION: 'Over Advance Interest',
  OVER_ADVANCE_INTEREST_RECOGNITION_DESCRIPTION:
    'Define when Open Balance interest becomes income: when it is charged (accrual) or when it is paid (cash).',
  WRITE_OFFS: 'Write Offs',
  WRITE_OFFS_DESCRIPTION: 'Enable Write Offs module',
  FEE_ESCROW: 'Fee Escrow',
  FEE_ESCROW_DESCRIPTION: 'Enable Fee Escrow module',
  OVER_PAYMENT_INVOICE_CREDIT: 'Over Payment Invoice Credit',
  OVER_PAYMENT_INVOICE_CREDIT_DESCRIPTION: 'Enable creating credits for over payments and out of system invoices',
  DEFAULT_PAYMENT_SERVICES: 'Default Payment Services',
  PAYMENT_SETUP: 'Payment Setup',
  FUNDING_SERVICES: 'Funding Services',
  CASH_BASED: 'Cash Based',
  ACCRUAL_BASED: 'Accrual Based',
  COLLECTION_FEE_METHOD: 'Collection Fee Method',
  COLLECTION_FEE_METHOD_DESCRIPTION: 'Define how collection fees are collected.',
  // END Fabian

  // BEGIN Patricio
  FACTOR_ACCRUED_INTEREST: 'Autocharge Accrued Interest',
  FACTOR_ACRRUED_FEES_FRECUENCY: 'Accrued Fees Frecuency',
  PAYMENT_BATCH_CODE: 'Payment Batch Code',
  DEFAULT_REMITTANCE_CLIENT_TEMPLATE: 'Remittance Client Template',
  DEFAULT_REMITTANCE_TEMPLATE_DESCRIPTION: 'Remittance template for sending e-mails to clients.',
  DEFAULT_STATEMENT_TEMPLATE: 'Debtor Statement Template',
  DEFAULT_STATEMENT_TEMPLATE_DESCRIPTION: 'Email template for Debtor Statements.',
  DEFAULT_REMITTANCE_BROKER_TEMPLATE: 'Remittance Broker Template',
  DEFAULT_REMITTANCE_BROKER_TEMPLATE_DESCRIPTION: 'Remittance template for sending e-mails to brokers.',
  DEFAULT_REMITTANCE_VENDOR_TEMPLATE: 'Remittance Vendor Template',
  DEFAULT_REMITTANCE_VENDOR_TEMPLATE_DESCRIPTION: 'Remittance template for sending e-mails to vendors.',

  EMAIL_CC_BCC: 'Email CC/BCC',
  TITLE_CC_BCC_SECTION: 'Create CC/BCC',
  TITLE_CREATE_CC_BCC: 'Create New',
  TITLE_EDIT_CC_BCC: 'Edit CC/BCC',

  DELETE_CC_BBC_EMAIL: 'Are you sure you want to delete this email?',
  DELETE_CC_BCC_EMAIL_SUCCESS: 'Email deleted successfully',
  CREATE_CC_BCC_EMAIL_SUCCESS: 'Email created successfully',
  EDIT_CC_BCC_EMAIL_SUCCESS: 'Email edited successfully',

  EMAIL_CC: 'CC',
  TOOLTIP_EDIT_EMAIL_CC: 'Edit Email CC',
  TOOLTIP_DELETE_EMAIL_CC: 'Delete Email CC',

  EMAIL_BCC: 'BCC',
  TOOLTIP_EDIT_EMAIL_BCC: 'Edit Email BCC',
  TOOLTIP_DELETE_EMAIL_BCC: 'Delete Email BCC',

  UPDATE_NOA_INVOICE_LEVEL: 'Update NOA Invoice Level Configuration',
  NOA_INVOICE_LEVEL_SETTING: 'NOA Invoice Level Setting',
  NOA_INVOICE_LEVEL_INFORMATION: 'NOA Level Information',
  NOA_INVOICE_LEVEL_FACTOR_SIGNATURE: 'Factor Signature',
  NOA_INVOICE_LEVEL_LEGAL_NOTICE: 'Legal Notice',
  NOA_INVOICE_IMAGE_SIGNATURE_INFO: 'You can upload your Signature as Image or Text',
  NO_SIGNATURE_AVAILABLE: 'No signature available',
  IMAGE_SIGNATURE: 'Image Signature',

  NOA_LEVEL: 'NOA Level',
  CLIENT_LEVEL: 'Client Level',
  INVOICE_LEVEL: 'Invoice Level',
  NOA_LEVEL_SETTING_TITLE: 'NOA Level Setting',
  NOA_LEVEL_SETTING_DESCRIPTION: 'Set the default NOA setting',
  NOA_PLACEMENT_SETTING_TITLE: 'NOA Placement',
  NOA_PLACEMENT_SETTING_DESCRIPTION: 'Set the default page position of the NOA in billing documents',
  NOA_PLACEMENT: 'NOA Placement',
  NOA_PLACEMENT_FIRST: 'First page',
  NOA_PLACEMENT_AFTER_FC_INVOICE: 'After FC Invoice',
  NOA_PLACEMENT_LAST: 'Last page',
  NOA_INVOICE_LEVEL_FACTOR_CONFIGURATION_UPDATED_SUCCESSFULLY: 'NOA Invoice Level Configuration updated successfully!',
  FACTOR_INFORMATION: 'Factor Information',

  AUTOMATED_FUNDING: 'Automated Funding',
  AUTOMATED_FUNDING_DESCRIPTION: 'Enable or disable Automated Funding',
  AUTO_FUNDING_PAYMENT_TYPES: 'Auto Fund by Funding Method',
  AUTO_FUNDING_PAYMENT_TYPES_DESCRIPTION:
    'Enable automated funding for selected payment methods. When enabled, all batches using those methods will be funded automatically without review, for all clients.',
  AUTO_FUNDING_ENABLED: 'Automated Funding By Payment Type',
  AUTO_FUNDING_ENABLED_DESCRIPTION:
    'Turn Auto Funding on or off. When disabled, selected funding methods will not be used for auto funding.',
  AUTO_FUNDING_NO_PAYMENT_METHODS: 'No payment methods active — nothing will be funded automatically.',
  AUTO_FUNDING_SELECTED_METHODS: 'Selected payment methods',
  AUTO_FUNDING_SELECT_METHODS_DESCRIPTION: 'Select the payment methods to include in automatic funding.',
  AUTO_FUNDING_WARNING_TITLE: 'Funds without review',
  AUTOMATIONS: 'Automations',
  AUTOMATED_INVOICE_APPROVAL: 'Automated Invoice Approval',
  AUTOMATED_INVOICE_APPROVAL_DESCRIPTION: 'Each client must be configured individually to activate auto-approval.',

  OVER_ADVANCE: 'Over Advance',
  FACTOR_CURRENCIES_DESCRIPTION: 'Enable or disable currency in the system',
  FACTOR_CURRENCIES_REQUIRED_DESCRIPTION: 'At least one currency must be selected.',
  FUEL_ADVANCE_CREDIT: 'Fuel Advance Credit',
  FUEL_ADVANCE_CREDIT_DESCRIPTION: 'Enable or disable Fuel Advance Credit',
  // END Patricio
  //BEGIN Esteban
  FACTOR_FUEL_ADVANCE: 'Enable Fuel Advance',
  FACTOR_INTEREST_RATE_PRIME: 'Prime Rate',
  FACTOR_INTEREST_RATE_SOFR: 'Sofr Rate',
  FACTOR_INTEREST_RATE_LIBOR: 'Libor Rate',
  FACTOR_TIMEZONE: 'Factor Timezone',
  FACTOR_TIMEZONE_DESCRIPTION: 'Factor Timezone Configuration',
  FACTOR_GROUP_SAME_DAY_INVOICES: 'Group Same Day Invoices',
  LEDGER_EXPORT_NAME: 'Ledger Export Name',
  FACTOR_ID: 'Factor ID',
  USER_ID: 'User ID',
  FIRTS_NAME: 'First Name',
  MIDDLE_NAME: 'Middle Name',
  LAST_NAME: 'Last Name',
  COMMUNITY_REINVESTMENT_ACT: 'Community Reinvestment Act',
  COMMUNITY_REINVESTMENT_ACT_DESCRIPTION: 'Enable or disable Community Reinvestment Act',
  //END Esteban
  FACTOR_ACCRUED_INTEREST_DESCRIPTION: 'Enable or disable Autocharge Accrued Interest',
  NACHA_FILE: 'NACHA File',
  NACHA_FILE_DESCRIPTION: 'Enable or disable NACHA File Export',
  NACHA_VERSION: 'NACHA Version',
  NACHA_VERSION_DESCRIPTION: 'Select NACHA file format version',
  NACHA_VERSION_1: 'Version 1',
  NACHA_VERSION_2: 'Version 2 (Incl. EIN)',
  NACHA_VERSION_3: 'Version 3 (Wells Fargo)',
  NACHA_OFFSET_ENTRY: 'Offsetting Entry',
  NACHA_OFFSET_ENTRY_DESCRIPTION: 'Include a balancing debit entry equal to the sum of all credits',
  NACHA_OFFSET_ENTRY_PREREQUISITES: 'Requires Check Payable Routing Number and Account to be configured',
  NACHA_V3_ENABLED: 'Configured',
  NACHA_V3_DISABLED: 'Not configured',
  NACHA_V3_CONFIGURE: 'Configure',
  NACHA_V3_TITLE: 'Wells Fargo NACHA Configuration',
  NACHA_V3_SUBTITLE: 'Configure the Wells Fargo-assigned identifiers used to generate NACHA v3 files.',
  NACHA_V3_REQUIRED_FIELDS_NOTE: 'Fields marked with * are required by Wells Fargo to generate the file.',
  NACHA_V3_COMPANY_NAME: 'Company Name',
  NACHA_V3_COMPANY_NAME_HELPER: 'Shown on the batch header. Leave blank to use the factor name as-is.',
  NACHA_V3_ERROR_COMPANY_NAME_MAX: 'Company Name must be 16 characters or fewer',
  NACHA_V3_COMPANY_ID: 'Company ID',
  NACHA_V3_COMPANY_ID_HELPER: 'Ten-character ID assigned by Wells Fargo (usually the same as the File ID)',
  NACHA_V3_STANDARD_ENTRY_CLASS_CODE: 'Standard Entry Class (SEC) Code',
  NACHA_V3_STANDARD_ENTRY_CLASS_CODE_HELPER: 'Three uppercase letters assigned by Wells Fargo, e.g. PPD or CCD',
  NACHA_V3_COMPANY_ENTRY_DESCRIPTION: 'Company Entry Description',
  NACHA_V3_COMPANY_DESCRIPTIVE_DATE: 'Company Descriptive Date',
  NACHA_V3_COMPANY_DESCRIPTIVE_DATE_HELPER: 'Optional free text shown to the receiver; defaults to the funding date if left blank',
  NACHA_V3_COMPANY_DISCRETIONARY_DATA: 'Company Discretionary Data',
  NACHA_V3_COMPANY_DISCRETIONARY_DATA_HELPER: 'Optional free text to help identify transactions in the batch',
  NACHA_V3_SAVE: 'Save',
  NACHA_V3_SAVE_SUCCESS: 'Wells Fargo NACHA configuration saved',
  NACHA_V3_SAVE_ERROR: 'Failed to save the Wells Fargo NACHA configuration',
  NACHA_V3_ERROR_COMPANY_ID_REQUIRED: 'Company ID is required',
  NACHA_V3_ERROR_COMPANY_ID_LENGTH: 'Company ID must be exactly 10 characters',
  NACHA_V3_ERROR_SEC_CODE_REQUIRED: 'Standard Entry Class Code is required',
  NACHA_V3_ERROR_SEC_CODE_PATTERN: 'Must be exactly 3 uppercase letters (e.g. PPD, CCD)',
  NACHA_V3_ERROR_ENTRY_DESCRIPTION_REQUIRED: 'Company Entry Description is required',
  NACHA_V3_ERROR_ENTRY_DESCRIPTION_MAX: 'Company Entry Description must be 10 characters or fewer',
  NACHA_V3_ERROR_DESCRIPTIVE_DATE_MAX: 'Company Descriptive Date must be 6 characters or fewer',
  NACHA_V3_ERROR_DISCRETIONARY_DATA_MAX: 'Company Discretionary Data must be 20 characters or fewer',
  NACHA_V3_INDIVIDUAL_ID_FLOOR: 'Individual ID Starting Number',
  NACHA_V3_INDIVIDUAL_ID_FLOOR_HELPER: 'Continues the correlative your previous system last used for each transaction reference',
  NACHA_V3_ERROR_INDIVIDUAL_ID_FLOOR_MIN: 'Individual ID Starting Number must be at least 1',
  NACHA_V3_LAST_INDIVIDUAL_ID_USED: 'Last Individual ID Used',
  NACHA_V3_LAST_INDIVIDUAL_ID_USED_EMPTY: 'None yet',
  SCOTIA_EFT_FILE: 'Scotiabank EFT File',
  SCOTIA_EFT_FILE_DESCRIPTION: 'Enable or disable Scotiabank EFT file export for Canadian carriers',
  EFT_CONFIGURE: 'Configure',
  EFT_ENABLED: 'Enabled',
  EFT_DISABLED: 'Disabled',
  EFT_ENABLE: 'Enable Scotiabank EFT File',
  EFT_TITLE: 'Scotiabank EFT Configuration',
  EFT_SUBTITLE: 'Configure the Scotiabank BNS Flat File settings used to export Canadian EFT payments.',
  EFT_REQUIRED_FIELDS_NOTE: 'Fields marked with * are required by Scotiabank to generate the file.',
  EFT_CUSTOMER_NUMBER: 'Customer Number',
  EFT_CUSTOMER_NAME: 'Customer Name',
  EFT_FUNDING_DFI: 'Funding Bank Number',
  EFT_FUNDING_ACCOUNT: 'Funding Account Number (CAD)',
  EFT_FUNDING_ACCOUNT_USD: 'Funding Account Number (USD)',
  EFT_CPA_CODE: 'CPA Code (CAD)',
  EFT_ORIGINATOR_SHORT_NAME: 'Originator Short Name',
  EFT_ORIGINATOR_LONG_NAME: 'Originator Long Name',
  EFT_FCN_FLOOR: 'File Number Start',
  EFT_FCN_FLOOR_HELPER: 'Must stay clear of file numbers your previous system already used this year',
  EFT_LAST_FCN_USED: 'Last File Number Used',
  EFT_LAST_FCN_USED_EMPTY: 'None yet',
  EFT_CPA_CODE_USD: 'CPA Code (USD)',
  EFT_TEST_MODE: 'Test Mode',
  EFT_TEST_MODE_DESCRIPTION: 'Flag files as test only. The bank validates them but does not move money.',
  EFT_SAVE: 'Save',
  EFT_SAVE_SUCCESS: 'Scotiabank EFT configuration saved',
  EFT_SAVE_ERROR: 'Failed to save the Scotiabank EFT configuration',
  EFT_ERROR_CUSTOMER_NUMBER_MAX: 'Customer Number must be 20 characters or fewer',
  EFT_ERROR_CUSTOMER_NAME_MAX: 'Customer Name must be 30 characters or fewer',
  EFT_ERROR_FUNDING_DFI_MAX: 'Funding Bank Number must be 11 characters or fewer',
  EFT_ERROR_FUNDING_ACCOUNT_MAX: 'Funding Account Number (CAD) must be 50 characters or fewer',
  EFT_ERROR_FUNDING_ACCOUNT_MAX_USD: 'Funding Account Number (USD) must be 50 characters or fewer',
  EFT_ERROR_CPA_CODE_MAX: 'CPA Code must be 3 characters or fewer',
  EFT_ERROR_ORIGINATOR_SHORT_NAME_MAX: 'Originator Short Name must be 15 characters or fewer',
  EFT_ERROR_ORIGINATOR_LONG_NAME_MAX: 'Originator Long Name must be 30 characters or fewer',
  EFT_ERROR_CUSTOMER_NUMBER_REQUIRED: 'Customer Number is required',
  EFT_ERROR_CUSTOMER_NAME_REQUIRED: 'Customer Name is required',
  EFT_ERROR_FUNDING_DFI_REQUIRED: 'Funding Bank Number is required',
  EFT_ERROR_FUNDING_ACCOUNT_REQUIRED: 'Funding Account Number (CAD) is required',
  EFT_ERROR_ORIGINATOR_SHORT_NAME_REQUIRED: 'Originator Short Name is required',
  EFT_ERROR_ORIGINATOR_LONG_NAME_REQUIRED: 'Originator Long Name is required',
  EFT_ERROR_FCN_FLOOR_MIN: 'File Number Start must be at least 1',
  EFT_ERROR_CPA_CODE_MAX_USD: 'CPA Code (USD) must be 3 characters or fewer',

  AI_AUTOMATED_PAYMENTS: 'Automated Payments (AI)',
  AI_AUTOMATED_PAYMENTS_DESCRIPTION: 'Enable or disable automated payments powered by AI',

  PORTAL_DUCT_WEBHOOK_BEARER_TOKEN: 'PortalDuct Webhook Bearer Token',
  PORTAL_DUCT_WEBHOOK_BEARER_TOKEN_DESCRIPTION: 'Webhook bearer token for PortalDuct integration',
  PORTAL_DUCT_INTEGRATION: 'PortalDuct Integration',
  PORTAL_DUCT_ENABLED: 'PortalDuct Enabled',
  PORTAL_DUCT_ENABLED_DESCRIPTION: 'Enable or disable PortalDuct integration',
  PORTAL_DUCT_UPDATE_SUCCESS: 'PortalDuct settings updated successfully',
  PORTAL_DUCT_CREATE_ROLE: 'Create PortalDuct Role',
  PORTAL_DUCT_CREATE_ROLE_SUCCESS: 'PortalDuct role created successfully',
}

export const factorsEs: typeof factorsEn = {
  // BEGIN Michael
  FACTOR: 'Factor',
  FACTORS: 'Factores',
  FACTOR_ACCOUNT_CREATED_SUCCESSFULLY: '¡Cuenta de factor creada con éxito!',
  UPDATE_FACTOR_INFORMATION: 'Actualizar información del factor',
  FACTOR_INFORMATION_UPDATED: '¡Información del factor actualizada con éxito!',
  BILLING_TEMPLATE: 'Plantilla de facturación',
  BILLING_TEMPLATE_DESCRIPTION: 'Plantilla de correo electrónico para enviar correos electrónicos a los deudores.',
  CONTACT_INFORMATION: 'Información de contacto',
  CONTACT_PHONE: 'Teléfono de contacto',
  CONTACT_EMAIL: 'Correo electrónico de contacto',
  CONTACT_INFORMATION_UPDATED: '¡Información de contacto actualizada con éxito!',
  UPDATE_CONTACT_INFORMATION: 'Actualizar información de contacto',
  SYSTEM_DEFAULTS: 'Valores predeterminados del sistema',
  SYSTEM_DEFAULTS_DESCRIPTION:
    'Estos valores se usan al crear entidades en el sistema. Cambiar estos valores solo afecta las nuevas entidades y no altera las existentes.',
  VENDOR_DEFAULTS_VALUES: 'Valores predeterminados del proveedor',
  VENDOR_DEFAULTS_VALUES_UPDATED: '¡Valores predeterminados del proveedor actualizados con éxito!',
  DEBTOR_DEFAULTS_VALUES: 'Valores predeterminados del deudor',
  DEBTOR_DEFAULTS_VALUES_UPDATED: '¡Valores predeterminados del deudor actualizados con éxito!',
  CLIENT_DEFAULTS_VALUES: 'Valores predeterminados del cliente',
  CLIENT_DEFAULTS_VALUES_UPDATED: '¡Valores predeterminados del cliente actualizados con éxito!',
  BROKER_DEFAULT_VALUES: 'Valores predeterminados del corredor',
  BROKER_DEFAULT_VALUES_UPDATED: '¡Valores predeterminados del corredor actualizados con éxito!',
  NO_BUY: 'No compra',
  NO_BUY_TOOLTIP: 'Cuando está habilitado, esta compañía queda marcada como No compra y no se puede comprar.',
  RELATIONSHIP_DEFAULT_VALUES: 'Valores predeterminados de la relación',
  RELATIONSHIP_DEFAULT_VALUES_UPDATED: '¡Valores predeterminados de la relación actualizados con éxito!',
  CURRENCY_SYMBOL: 'Símbolo de divisa',
  CURRENCY_SYMBOL_DESCRIPTION: 'Habilitar o deshabilitar el símbolo de divisa',
  CURRENCY_FILTER: 'Filtro de moneda',
  CURRENCY_FILTER_DESCRIPTION: 'Habilitar o deshabilitar el filtro de moneda',
  CURRENT_CURRENCY_FILTER: 'Filtro de moneda actual',
  PREFERRED_PAYMENT_METHOD_COLUMN: 'Columna de método de pago preferido',
  PREFERRED_PAYMENT_METHOD_COLUMN_DESCRIPTION: 'Mostrar la columna de método de pago preferido en facturas pendientes',
  BENCHMARK: 'Punto de referencia',
  INVOICE_PROCESSING: 'Procesamiento de facturas',
  PERMISSIONS: 'Permisos',
  REQUIRED_DUE_DATE: 'Fecha de vencimiento requerida',
  REQUIRED_DUE_DATE_DESCRIPTION:
    'Habilitar o deshabilitar la fecha de vencimiento requerida en la creación de facturas',
  COST_OF_FUNDS: 'Costo de fondos',
  COST_OF_FUNDS_DESCRIPTION: 'Habilitar o deshabilitar el cálculo del costo de los fondos',
  COST_OF_FUNDS_FIELDS_UPDATED_SUCCESSFULLY: '¡Campos de costo de fondos actualizados con éxito!',
  UPDATE_COST_OF_FUNDS: 'Actualizar costo de fondos',
  // END Michael
  // BEGIN Fco
  BROKER_MOD: 'Broker Mod',
  FACTOR_ENABLE_BROKER_MOD: 'Habilitar o deshabilitar Broker Mod',
  FACTOR_GROUP_SAME_DAY_INVOICES_DESC: 'Agrupar facturas del mismo día en un lote de pagos',
  FACTOR_ENABLE_ALLOW_DUPLICATE_REFERENCE_NUMBERS: 'Habilitar números de referencia duplicados',
  FACTOR_ENABLE_ALLOW_DUPLICATE_REFERENCE_NUMBERS_DESC:
    'Permitir que las facturas tengan números de referencia duplicados.',
  // END Fco
  // BEGIN Fabian
  ACTIVATED_FACTOR: 'Activar Factor',
  DESACTIVATED_FACTOR: 'Desactivar Factor',
  ACTIVATED: 'Activado',
  DESACTIVATED: 'Desactivado',
  UPDATED: 'Actualizado',
  CREATED: 'Creado',
  FACTOR_ACTIVATED_SUCCESSFULLY: '¡Factor activado con éxito!',
  FACTOR_DESACTIVATED_SUCCESSFULLY: '¡Factor desactivado con éxito!',
  UPDATE_FACTOR: 'Actualizar Factor',
  CREATE_FACTOR: 'Crear Factor',
  CONFIRM_ACTIVATE_FACTOR: '¿Está seguro de que desea activar el factor desde el estado inactivo?',
  CONFIRM_DESACTIVATE_FACTOR: '¿Está seguro de que desea desactivar el factor desde el estado activo?',
  EMAIL_TEMPLATE_ALERT_INFORMATION:
    'Las variables que se pueden utilizar en el asunto y el cuerpo pueden ser las siguientes:',
  CLIENT_NAME: 'Nombre del cliente',
  DEBTOR_NAME: 'Nombre del deudor',
  EMAIL_TEMPLATES: 'Plantillas de correo electrónico',
  DEFAULT_NOA_TEMPLATE: 'Plantilla NOA',
  DEFAULT_NOA_TEMPLATE_DESCRIPTION: 'NOA plantilla para enviar correos electrónicos a los deudores.',
  PAYMENT_ACCOUNTS: 'Cuentas de pago',
  CREATE_PAYMENT_ACCOUNT: 'Crear cuenta de pago',
  EDIT_PAYMENT_ACCOUNT: 'Editar cuenta de pago',
  EDIT_PAYMENT_ACCOUNT_SUCCESS: 'Cuenta de pago editada con éxito',
  DELETE_PAYMENT_ACCOUNT: '¿Estás seguro de que quieres eliminar esta cuenta de pago?',
  DELETE_PAYMENT_ACCOUNT_SUCCESS: 'Cuenta de pago eliminada con éxito',
  DELETE_PAYMENT_ACCOUNT_DISABLED:
    'La eliminación de una cuenta de pago está temporalmente deshabilitada mientras se desarrolla un flujo de desactivación más seguro. Contactá a ingeniería si es necesario eliminar una cuenta.',
  BACKDATING_PAYMENTS: 'Permitir pagos retroactivos',
  BACKDATING_PAYMENTS_DESCRIPTION: 'Cuando se aplica un pago, las tarifas devengadas se ajustarán a la fecha del pago.',
  OVER_ADVANCES: 'Over Advances',
  OVER_ADVANCES_DESCRIPTION: 'Habilitar módulo de Over Advances',
  OPEN_BALANCE_OVER_ADVANCES: 'Over Advances Open Balance',
  OPEN_BALANCE_OVER_ADVANCES_DESCRIPTION: 'Permitir over advances Open Balance, sus plantillas y el interés nocturno',
  OVER_ADVANCE_INTEREST_RECOGNITION: 'Interés de Over Advances',
  OVER_ADVANCE_INTEREST_RECOGNITION_DESCRIPTION:
    'Defina cuándo el interés de Open Balance se reconoce como ingreso: al cargarse (accrual) o al pagarse (cash).',
  WRITE_OFFS: 'Write Offs',
  WRITE_OFFS_DESCRIPTION: 'Habilitar módulo de Write Offs',
  FEE_ESCROW: 'Fee Escrow',
  FEE_ESCROW_DESCRIPTION: 'Habilitar módulo de Fee Escrow',
  OVER_PAYMENT_INVOICE_CREDIT: 'Crédito por Sobrepago',
  OVER_PAYMENT_INVOICE_CREDIT_DESCRIPTION: 'Habilitar la creación de créditos por sobrepagos y facturas fuera de sistema',
  DEFAULT_PAYMENT_SERVICES: 'Servicios de pago predeterminados',
  PAYMENT_SETUP: 'Configuración de pago',
  FUNDING_SERVICES: 'Servicios de financiación',
  CASH_BASED: 'Cash Based',
  ACCRUAL_BASED: 'Accrual Based',
  COLLECTION_FEE_METHOD: 'Método de cobro de comisiones',
  COLLECTION_FEE_METHOD_DESCRIPTION: 'Defina cómo se cobran los gastos de cobro.',
  // END Fabian

  // BEGIN Patricio
  FACTOR_ACCRUED_INTEREST: 'Intereses devengados de autocarga',
  FACTOR_ACRRUED_FEES_FRECUENCY: 'Frecuencia de cuotas devengadas',
  PAYMENT_BATCH_CODE: 'Código de lote de pago',
  DEFAULT_REMITTANCE_CLIENT_TEMPLATE: 'Plantilla de remesas de clientes',
  DEFAULT_REMITTANCE_TEMPLATE_DESCRIPTION: 'Plantilla de remesas para enviar correos electrónicos a los clientes.',
  DEFAULT_STATEMENT_TEMPLATE: 'Plantilla de estado deudor',
  DEFAULT_STATEMENT_TEMPLATE_DESCRIPTION: 'Plantilla de correo electrónico para las declaraciones de deudores.',
  DEFAULT_REMITTANCE_BROKER_TEMPLATE: 'Plantilla de remesas de corredores',
  DEFAULT_REMITTANCE_BROKER_TEMPLATE_DESCRIPTION: 'Plantilla de remesas para enviar correos electrónicos a corredores.',
  DEFAULT_REMITTANCE_VENDOR_TEMPLATE: 'Plantilla de remesas de proveedores',
  DEFAULT_REMITTANCE_VENDOR_TEMPLATE_DESCRIPTION:
    'Plantilla de remesas para enviar correos electrónicos a proveedores.',

  EMAIL_CC_BCC: 'Correo electrónico CC/BCC',
  TITLE_CC_BCC_SECTION: 'CC.BCC para correo electrónico',
  TITLE_CREATE_CC_BCC: 'Crear Nuevo',
  TITLE_EDIT_CC_BCC: 'Editar CC/BCC',
  DELETE_CC_BBC_EMAIL: '¿Estás seguro de que quieres eliminar este correo electrónico?',
  DELETE_CC_BCC_EMAIL_SUCCESS: 'Correo electrónico eliminado con éxito',
  CREATE_CC_BCC_EMAIL_SUCCESS: 'Correo electrónico creado con éxito',
  EDIT_CC_BCC_EMAIL_SUCCESS: 'Correo electrónico editado con éxito',

  EMAIL_CC: 'CC',
  TOOLTIP_EDIT_EMAIL_CC: 'Editar Email CC',
  TOOLTIP_DELETE_EMAIL_CC: 'Eliminar Email CC',

  EMAIL_BCC: 'BCC',
  TOOLTIP_EDIT_EMAIL_BCC: 'Editar Email BCC',
  TOOLTIP_DELETE_EMAIL_BCC: 'Eliminar Email BCC',

  UPDATE_NOA_INVOICE_LEVEL: 'Actualizar la configuración del nivel de facturación de NOA.',
  NOA_INVOICE_LEVEL_SETTING: 'Configuración NOA Nivel Factura',
  NOA_INVOICE_LEVEL_INFORMATION: 'Información de nivel de NOA',
  NOA_INVOICE_LEVEL_FACTOR_SIGNATURE: 'Firma de Factor',
  NOA_INVOICE_LEVEL_LEGAL_NOTICE: 'Aviso Legal',
  NOA_INVOICE_IMAGE_SIGNATURE_INFO: 'Puede cargar su firma como imagen o texto',
  NO_SIGNATURE_AVAILABLE: 'No hay firma disponible',
  IMAGE_SIGNATURE: 'Imagen de la firma',

  NOA_LEVEL: 'Nivel de NOA',
  CLIENT_LEVEL: 'Nivel de Cliente',
  INVOICE_LEVEL: 'Nivel de Factura',
  NOA_LEVEL_SETTING_TITLE: 'Configuración de nivel de NOA',
  NOA_LEVEL_SETTING_DESCRIPTION: 'Establecer la configuración predeterminada de NOA',
  NOA_PLACEMENT_SETTING_TITLE: 'Posición del NOA',
  NOA_PLACEMENT_SETTING_DESCRIPTION: 'Establece la posición predeterminada del NOA en los documentos de facturación',
  NOA_PLACEMENT: 'Posición del NOA',
  NOA_PLACEMENT_FIRST: 'Primera página',
  NOA_PLACEMENT_AFTER_FC_INVOICE: 'Después de la factura FC',
  NOA_PLACEMENT_LAST: 'Última página',
  NOA_INVOICE_LEVEL_FACTOR_CONFIGURATION_UPDATED_SUCCESSFULLY: '¡Configuración de nivel de NOA actualizada con éxito!',
  FACTOR_INFORMATION: 'Información del Factor',

  AUTOMATED_FUNDING: 'Financiamiento automatizado',
  AUTOMATED_FUNDING_DESCRIPTION: 'Habilitar o deshabilitar el financiamiento automatizado',
  AUTO_FUNDING_PAYMENT_TYPES: 'Auto-fondear por método de pago',
  AUTO_FUNDING_PAYMENT_TYPES_DESCRIPTION:
    'Habilita el fondeo automático para los métodos de pago seleccionados. Cuando está activo, todos los lotes que usen esos métodos se fondean automáticamente sin revisión, para todos los clientes.',
  AUTO_FUNDING_ENABLED: 'Fondeo automático por método de pago',
  AUTO_FUNDING_ENABLED_DESCRIPTION:
    'Activá o desactivá Auto Funding. Si está desactivado, los métodos de pago seleccionados no se usarán para el fondeo automático.',
  AUTO_FUNDING_NO_PAYMENT_METHODS: 'No hay métodos de pago activos — no se fondeará nada automáticamente.',
  AUTO_FUNDING_SELECTED_METHODS: 'Métodos de pago seleccionados',
  AUTO_FUNDING_SELECT_METHODS_DESCRIPTION: 'Seleccioná los métodos de pago a incluir en el fondeo automático.',
  AUTO_FUNDING_WARNING_TITLE: 'Fondea sin revisión',
  AUTOMATIONS: 'Automatizaciones',
  AUTOMATED_INVOICE_APPROVAL: 'Aprobación automática de facturas',
  AUTOMATED_INVOICE_APPROVAL_DESCRIPTION: 'Cada cliente debe configurarse individualmente para activar la aprobación automática.',
  OVER_ADVANCE: 'Over Advance',
  FACTOR_CURRENCIES_DESCRIPTION: 'Habilitar o deshabilitar la moneda en el sistema',
  FACTOR_CURRENCIES_REQUIRED_DESCRIPTION: 'Debe seleccionar al menos una moneda.',

  FUEL_ADVANCE_CREDIT: 'Crédito por adelanto de combustible',
  FUEL_ADVANCE_CREDIT_DESCRIPTION: 'Habilitar o deshabilitar el crédito por adelanto de combustible',
  // END Patricio
  //BEGIN Esteban
  FACTOR_FUEL_ADVANCE: 'Habilitar avance por combustible',
  FACTOR_INTEREST_RATE_PRIME: 'Tasa Prime',
  FACTOR_INTEREST_RATE_SOFR: 'Tasa Sofr',
  FACTOR_INTEREST_RATE_LIBOR: 'Tasa Libor',
  FACTOR_TIMEZONE: 'Zona Horaria para el Factor',
  FACTOR_TIMEZONE_DESCRIPTION: 'Configuración de zona Horaria para el Factor',
  FACTOR_GROUP_SAME_DAY_INVOICES: 'Agrupar facturas del mismo día',
  LEDGER_EXPORT_NAME: 'Nombre de exportación de libro mayor',
  FACTOR_ID: 'ID del Factor',
  USER_ID: 'ID de Usuario',
  FIRTS_NAME: 'Primer Nombre',
  MIDDLE_NAME: 'Segundo Nombre',
  LAST_NAME: 'Apellido',
  COMMUNITY_REINVESTMENT_ACT: 'Ley de Reinversión Comunitaria',
  COMMUNITY_REINVESTMENT_ACT_DESCRIPTION: 'Habilitar o deshabilitar la Ley de Reinversión Comunitaria',
  //END Esteban
  FACTOR_ACCRUED_INTEREST_DESCRIPTION: 'Activar o desactivar la autocarga de intereses devengados',
  NACHA_FILE: 'Archivo NACHA',
  NACHA_FILE_DESCRIPTION: 'Habilitar o deshabilitar la exportación de archivos NACHA',
  NACHA_VERSION: 'Versión NACHA',
  NACHA_VERSION_DESCRIPTION: 'Seleccionar versión del formato de archivo NACHA',
  NACHA_VERSION_1: 'Versión 1',
  NACHA_VERSION_2: 'Versión 2 (Incl. EIN)',
  NACHA_VERSION_3: 'Versión 3 (Wells Fargo)',
  NACHA_OFFSET_ENTRY: 'Entrada de compensación',
  NACHA_OFFSET_ENTRY_DESCRIPTION: 'Incluir una entrada de débito de saldo igual a la suma de todos los créditos',
  NACHA_OFFSET_ENTRY_PREREQUISITES:
    'Requiere que el Número de enrutamiento y Número de cuenta del beneficiario estén configurados',
  NACHA_V3_ENABLED: 'Configurado',
  NACHA_V3_DISABLED: 'No configurado',
  NACHA_V3_CONFIGURE: 'Configurar',
  NACHA_V3_TITLE: 'Configuración NACHA de Wells Fargo',
  NACHA_V3_SUBTITLE: 'Configurá los identificadores asignados por Wells Fargo que se usan para generar archivos NACHA v3.',
  NACHA_V3_REQUIRED_FIELDS_NOTE: 'Los campos marcados con * son requeridos por Wells Fargo para generar el archivo.',
  NACHA_V3_COMPANY_NAME: 'Company Name',
  NACHA_V3_COMPANY_NAME_HELPER: 'Aparece en el batch header. Dejalo vacío para usar el nombre del factor tal cual.',
  NACHA_V3_ERROR_COMPANY_NAME_MAX: 'Company Name debe tener 16 caracteres o menos',
  NACHA_V3_COMPANY_ID: 'Company ID',
  NACHA_V3_COMPANY_ID_HELPER: 'ID de diez caracteres asignado por Wells Fargo (usualmente el mismo que el File ID)',
  NACHA_V3_STANDARD_ENTRY_CLASS_CODE: 'Código Standard Entry Class (SEC)',
  NACHA_V3_STANDARD_ENTRY_CLASS_CODE_HELPER: 'Tres letras mayúsculas asignadas por Wells Fargo, ej. PPD o CCD',
  NACHA_V3_COMPANY_ENTRY_DESCRIPTION: 'Company Entry Description',
  NACHA_V3_COMPANY_DESCRIPTIVE_DATE: 'Company Descriptive Date',
  NACHA_V3_COMPANY_DESCRIPTIVE_DATE_HELPER:
    'Texto libre opcional mostrado al receptor; si se deja vacío usa la fecha de financiamiento',
  NACHA_V3_COMPANY_DISCRETIONARY_DATA: 'Company Discretionary Data',
  NACHA_V3_COMPANY_DISCRETIONARY_DATA_HELPER: 'Texto libre opcional para identificar las transacciones del batch',
  NACHA_V3_SAVE: 'Guardar',
  NACHA_V3_SAVE_SUCCESS: 'Configuración NACHA de Wells Fargo guardada',
  NACHA_V3_SAVE_ERROR: 'No se pudo guardar la configuración NACHA de Wells Fargo',
  NACHA_V3_ERROR_COMPANY_ID_REQUIRED: 'Company ID es requerido',
  NACHA_V3_ERROR_COMPANY_ID_LENGTH: 'Company ID debe tener exactamente 10 caracteres',
  NACHA_V3_ERROR_SEC_CODE_REQUIRED: 'El código Standard Entry Class es requerido',
  NACHA_V3_ERROR_SEC_CODE_PATTERN: 'Deben ser exactamente 3 letras mayúsculas (ej. PPD, CCD)',
  NACHA_V3_ERROR_ENTRY_DESCRIPTION_REQUIRED: 'Company Entry Description es requerido',
  NACHA_V3_ERROR_ENTRY_DESCRIPTION_MAX: 'Company Entry Description debe tener 10 caracteres o menos',
  NACHA_V3_ERROR_DESCRIPTIVE_DATE_MAX: 'Company Descriptive Date debe tener 6 caracteres o menos',
  NACHA_V3_ERROR_DISCRETIONARY_DATA_MAX: 'Company Discretionary Data debe tener 20 caracteres o menos',
  NACHA_V3_INDIVIDUAL_ID_FLOOR: 'Número Inicial de Individual ID',
  NACHA_V3_INDIVIDUAL_ID_FLOOR_HELPER: 'Continúa el correlativo que usaba el sistema anterior para la referencia de cada transacción',
  NACHA_V3_ERROR_INDIVIDUAL_ID_FLOOR_MIN: 'El Número Inicial de Individual ID debe ser al menos 1',
  NACHA_V3_LAST_INDIVIDUAL_ID_USED: 'Último Individual ID Usado',
  NACHA_V3_LAST_INDIVIDUAL_ID_USED_EMPTY: 'Todavía ninguno',
  SCOTIA_EFT_FILE: 'Archivo EFT Scotiabank',
  SCOTIA_EFT_FILE_DESCRIPTION: 'Habilitar o deshabilitar la exportación de archivos EFT de Scotiabank para carriers canadienses',
  EFT_CONFIGURE: 'Configurar',
  EFT_ENABLED: 'Habilitado',
  EFT_DISABLED: 'Deshabilitado',
  EFT_ENABLE: 'Habilitar archivo EFT de Scotiabank',
  EFT_TITLE: 'Configuración EFT de Scotiabank',
  EFT_SUBTITLE: 'Configure los parámetros del archivo BNS Flat File de Scotiabank usados para exportar pagos EFT canadienses.',
  EFT_REQUIRED_FIELDS_NOTE: 'Los campos marcados con * son requeridos por Scotiabank para generar el archivo.',
  EFT_CUSTOMER_NUMBER: 'Número de cliente',
  EFT_CUSTOMER_NAME: 'Nombre del cliente',
  EFT_FUNDING_DFI: 'Número del banco de fondeo',
  EFT_FUNDING_ACCOUNT: 'Número de cuenta de fondeo (CAD)',
  EFT_FUNDING_ACCOUNT_USD: 'Número de cuenta de fondeo (USD)',
  EFT_CPA_CODE: 'Código CPA (CAD)',
  EFT_ORIGINATOR_SHORT_NAME: 'Nombre corto del originador',
  EFT_ORIGINATOR_LONG_NAME: 'Nombre largo del originador',
  EFT_FCN_FLOOR: 'Número inicial de archivo',
  EFT_FCN_FLOOR_HELPER: 'Debe evitar los números de archivo que su sistema anterior ya usó este año',
  EFT_LAST_FCN_USED: 'Último número de archivo usado',
  EFT_LAST_FCN_USED_EMPTY: 'Aún ninguno',
  EFT_CPA_CODE_USD: 'Código CPA (USD)',
  EFT_TEST_MODE: 'Modo de prueba',
  EFT_TEST_MODE_DESCRIPTION: 'Marcar los archivos como prueba. El banco los valida pero no transfiere dinero.',
  EFT_SAVE: 'Guardar',
  EFT_SAVE_SUCCESS: 'Configuración EFT de Scotiabank guardada',
  EFT_SAVE_ERROR: 'No se pudo guardar la configuración EFT de Scotiabank',
  EFT_ERROR_CUSTOMER_NUMBER_MAX: 'El número de cliente debe tener 20 caracteres o menos',
  EFT_ERROR_CUSTOMER_NAME_MAX: 'El nombre del cliente debe tener 30 caracteres o menos',
  EFT_ERROR_FUNDING_DFI_MAX: 'El número del banco de fondeo debe tener 11 caracteres o menos',
  EFT_ERROR_FUNDING_ACCOUNT_MAX: 'El número de cuenta de fondeo (CAD) debe tener 50 caracteres o menos',
  EFT_ERROR_FUNDING_ACCOUNT_MAX_USD: 'El número de cuenta de fondeo (USD) debe tener 50 caracteres o menos',
  EFT_ERROR_CPA_CODE_MAX: 'El código CPA debe tener 3 caracteres o menos',
  EFT_ERROR_ORIGINATOR_SHORT_NAME_MAX: 'El nombre corto del originador debe tener 15 caracteres o menos',
  EFT_ERROR_ORIGINATOR_LONG_NAME_MAX: 'El nombre largo del originador debe tener 30 caracteres o menos',
  EFT_ERROR_CUSTOMER_NUMBER_REQUIRED: 'El número de cliente es requerido',
  EFT_ERROR_CUSTOMER_NAME_REQUIRED: 'El nombre del cliente es requerido',
  EFT_ERROR_FUNDING_DFI_REQUIRED: 'El número del banco de fondeo es requerido',
  EFT_ERROR_FUNDING_ACCOUNT_REQUIRED: 'El número de cuenta de fondeo (CAD) es requerido',
  EFT_ERROR_ORIGINATOR_SHORT_NAME_REQUIRED: 'El nombre corto del originador es requerido',
  EFT_ERROR_ORIGINATOR_LONG_NAME_REQUIRED: 'El nombre largo del originador es requerido',
  EFT_ERROR_FCN_FLOOR_MIN: 'El número inicial de archivo debe ser al menos 1',
  EFT_ERROR_CPA_CODE_MAX_USD: 'El código CPA (USD) debe tener 3 caracteres o menos',

  AI_AUTOMATED_PAYMENTS: 'Pagos automatizados por IA',
  AI_AUTOMATED_PAYMENTS_DESCRIPTION: 'Habilitar o deshabilitar los pagos automatizados por IA',

  PORTAL_DUCT_WEBHOOK_BEARER_TOKEN: 'Token de Portador Webhook de PortalDuct',
  PORTAL_DUCT_WEBHOOK_BEARER_TOKEN_DESCRIPTION: 'Token de portador para la integración con PortalDuct',
  PORTAL_DUCT_INTEGRATION: 'Integración PortalDuct',
  PORTAL_DUCT_ENABLED: 'PortalDuct Habilitado',
  PORTAL_DUCT_ENABLED_DESCRIPTION: 'Habilitar o deshabilitar la integración con PortalDuct',
  PORTAL_DUCT_UPDATE_SUCCESS: 'Configuración de PortalDuct actualizada exitosamente',
  PORTAL_DUCT_CREATE_ROLE: 'Crear Rol PortalDuct',
  PORTAL_DUCT_CREATE_ROLE_SUCCESS: 'Rol PortalDuct creado exitosamente',
}
